import styled from 'styled-components';

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  height: 100px;
  max-height: 150px;
`;
export default TitleWrapper;
